module.exports = __webpack_public_path__ + "img/chinesecompany138.2478240d.png";